module.exports = __webpack_public_path__ + "static/img/cart3.f3c6d21.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cart3.png
// module id = zdtu
// module chunks = 2